import React from 'react'
import WidgetSelector from './WidgetSelector'

export default function WidgetItemBrandSelector({
  value,
  displayValue,
  item_brands,
  onChange,
  viewOnly,
  reloadDropdownData,
  size,
  placeHolder
}) {
  return (
    <React.Fragment>
      <WidgetSelector
        viewOnly={viewOnly || false}
        selectedValue={value}
        displayValue={displayValue}
        options={item_brands}
        onChange={(values) => onChange(values)}
        reloadDropdownData={() => reloadDropdownData()}
        placeHolder={placeHolder}
        showCloudIcon={true}
        size={size}
      />
    </React.Fragment>
  )
}
